export default __webpack_public_path__ + "static/media/specimendealer.2b0cbab1.png";